import React, {useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './components/pages/LandingPage';
import UploadForm from './components/UploadForm';
import AboutPage from './components/pages/About';
import ContactPage from './components/pages/Contact';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import './App.css';
import { AppProvider } from './context/appContext.js';
import { useLocation } from 'react-router-dom';
import PasswordGate from './components/PasswordGate.js';
import CookieBanner from './components/layout/CookieBanner.js';
import Cookies from 'js-cookie';
import { API_BASE } from './components/Config.js';

function Content() {
  const { pathname } = useLocation();
  const pageClass = pathname === '/'
    ? 'home'
    : pathname.slice(1).replace(/\//g, '-');

    
  return (
    <>
    <CookieBanner />
      <Navbar />
      <div className={`content-container ${pageClass}`}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/upload" element={<UploadForm />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

export default function App() {


  return (
  
      <>
        <AppProvider>
          <Router>
            <Content />
          </Router>
        </AppProvider>
        </>
    
    

  );
}

